var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",staticClass:"grey",staticStyle:{"width":"100%"},style:(`height: ${_vm.height};`),attrs:{"id":"units_map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }